module.exports = __webpack_public_path__ + "img/home-discovery-packages-image.cfaeddc2.png";